import { createAsyncThunk } from '@reduxjs/toolkit';
import { UsersApi, OneTimeSessionTokenDTO } from '@reposit/api-client';
import { FlashState } from '../../components/FlashMessage';
import { getErrorMessage } from '../../utils/common.utils';
import {
  BULK_IMPORT_REPOSITS_STORE_KEY,
  BULK_IMPORT_REPOSITS_API_REQUESTED,
  BULK_IMPORT_REPOSITS_API_SUCCESS,
  BULK_IMPORT_REPOSITS_API_FAILED,
} from './reposit-list.actions';
import { internalSessionRequestOptions } from '../auth/internal-session';
import { setFlashMessage } from '../flash-messages/flash-messages.actions';
import { AppState } from '../root.reducer';
import { createStandardUsersApi, runThunkWithAuth } from '../utils/api.utils';
import { AxiosResponse } from 'axios';
import { appConfig } from '../../appConfig';

export const bulkImportRepositsThunk = createAsyncThunk<
  void,
  void,
  {
    state: AppState;
  }
>('reposit-list/bulk-import', async (payload, thunkAPI) => {
  const { newAdminUrl } = appConfig;
  const state = thunkAPI.getState();
  const dispatch = thunkAPI.dispatch;
  
  dispatch({ type: BULK_IMPORT_REPOSITS_API_REQUESTED });
  
  try {
    const usersApi: UsersApi = createStandardUsersApi(state, dispatch);
    const {
      data: { token },
    }: AxiosResponse<OneTimeSessionTokenDTO> = await runThunkWithAuth(
      () => usersApi.createOneTimeSessionToken(internalSessionRequestOptions),
      dispatch,
    );

    window.open(`${newAdminUrl}/auth/transfer-session?token=${token}&redirectUrl=/bulk-import`, '_blank');
    
    dispatch({ type: BULK_IMPORT_REPOSITS_API_SUCCESS });
  } catch (e) {
    dispatch({ type: BULK_IMPORT_REPOSITS_API_FAILED });
    
    const error = getErrorMessage(e);
    dispatch(
      setFlashMessage({
        key: BULK_IMPORT_REPOSITS_STORE_KEY,
        message: error,
        state: FlashState.ERROR,
      })
    );
  }
});
